module.exports = __webpack_public_path__ + "img/menu1.08b2e0f7.png";